import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

@observer
class Autocomplete extends Component {
    handleOnInput = (e) => {
        const { oninput } = this.props;
        this.setState({
            searchText: e.target.value,
        });
        oninput(e);
    }

    keyDown = (e) => {
        const { handleKeydown = () => {} } = this.props;
        handleKeydown(e);
    }

    onFocus = () => {
        this.setState({ isActive: true });
    }

    onBlur = () => {
        this.setState({ isActive: false });
    }

    render() {
        const {
            name,
            type,
            disabled = false,
            placeholder = '',
            removeElement = () => {},
            addElement = () => {},
            autocompleteList: myAutocompleteList = [],
            value = [],
            currentIdx = 0,
            currentId = 0,
            valueDisplayMap = v => v,
            total,
        } = this.props;
        const { isActive } = this.state;

        return (
            <div>
                <input
                    class='form-control'
                    type={type}
                    name={`${name}Search`}
                    disabled={!!disabled}
                    aria-describedby={`${name}Help`}
                    placeholder={placeholder}
                    onInput={this.handleOnInput}
                    onKeyDown={this.keyDown}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />
                <div class='row'>
                    {isActive && <div class='col-sm-12'>
                        <ul class='list-group'>
                            {myAutocompleteList && myAutocompleteList.map((el, idx) => (
                                <li class={`list-group-item ${currentIdx === idx ? 'bg-primary text-white' : ''}`}
                                    onClick={() => addElement(idx)}
                                >
                                    { valueDisplayMap(el) }
                                </li>
                            ))}
                        </ul>
                    </div>}
                    <div class='col-sm-12'>
                        {value && value.map(val => <span class={`badge badge-${val.id == currentId ? 'success p-3' : 'primary'} mr-2`}>
                            { valueDisplayMap(val) }
                            <i class='ml-2 fas fa-times-circle'
                                onClick={() => removeElement(val.id)}
                            />
                        </span>)}
                    </div>
                </div>
            </div>
        );
    }
}

export default Autocomplete;


// WEBPACK FOOTER //
// ./components/form/autocomplete.js